// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ol, ul {
  margin: 0;
  padding: 0;
}

.auth {
  max-width: 376px;
  padding: 1rem;
  border: 1px solid #b5c6e2;
  border-radius: 0.375rem;
}

.auth__method {
  display: flex;
  height: auto;
  list-style: none;
  text-align: center;
  border: 1px solid #b5c6e2;
  border-radius: 0.375rem;
}

.auth__method-item {
  width: 50%;
}

.auth__method-item-link {
  padding: 0.5rem;
  color: #6589d9;
  font-weight: 700;
  display: block;
  border: 0;
  text-decoration: none;
}

.auth__method-item-link.active {
  background-color: #d4def2;
  border-radius: 0.375rem;
  color: #3a5e8a;
}

.auth .tab-content {
  padding-top: 1.25rem;
}

.auth .btn {
  font-size: 0.875rem;
  font-weight: 600;
  width: 100%;
}

.auth-separator {
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
}

.auth-separator::before, .auth-separator::after {
  position: relative;
  display: inline-block;
  width: 50%;
  height: 1px;
  vertical-align: middle;
  content: "";
  background-color: #d1d9e0;
}

.auth-separator::before {
  right: 0.5rem;
}

.auth-separator::after {
  left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/auth.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AACF;;AACA;EACE,UAAA;AAEF;;AAAA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,qBAAA;AAGF;;AADA;EACE,yBAAA;EACA,uBAAA;EACA,cAAA;AAIF;;AADA;EACE,oBAAA;AAIF;;AADA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAIF;;AADA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;AAIF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,YAAA;AAIF","sourcesContent":["ol, ul {\n  margin: 0;\n  padding: 0;\n}\n\n.auth {\n  max-width: 376px;\n  padding: 1rem;\n  border: 1px solid #b5c6e2;\n  border-radius: 0.375rem;\n}\n\n.auth__method {\n  display: flex;\n  height: auto;\n  list-style: none;\n  text-align: center;\n  border: 1px solid #b5c6e2;\n  border-radius: 0.375rem;\n}\n.auth__method-item {\n  width: 50%;\n}\n.auth__method-item-link {\n  padding: 0.5rem;\n  color: #6589d9;\n  font-weight: 700;\n  display: block;\n  border: 0;\n  text-decoration: none;\n}\n.auth__method-item-link.active {\n  background-color: #d4def2;\n  border-radius: 0.375rem;\n  color: #3a5e8a;\n}\n\n.auth .tab-content {\n  padding-top: 1.25rem;\n}\n\n.auth .btn {\n  font-size: 0.875rem;\n  font-weight: 600;\n  width: 100%;\n}\n\n.auth-separator {\n  display: flex;\n  align-items: center;\n  margin: 1.5rem 0;\n}\n\n.auth-separator::before, .auth-separator::after {\n  position: relative;\n  display: inline-block;\n  width: 50%;\n  height: 1px;\n  vertical-align: middle;\n  content: \"\";\n  background-color: #d1d9e0;\n}\n\n.auth-separator::before {\n  right: 0.5rem;\n}\n\n.auth-separator::after {\n  left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
